import { render } from "./ChangeUserEmail.vue?vue&type=template&id=9640124e&scoped=true"
import script from "./ChangeUserEmail.vue?vue&type=script&lang=js"
export * from "./ChangeUserEmail.vue?vue&type=script&lang=js"

import "./ChangeUserEmail.vue?vue&type=style&index=0&id=9640124e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9640124e"]])

export default __exports__